import { SDGImage } from "./style";

const SDGCard = ({ SDG }) => {
	return <SDGImage src={SDG} />;
};

export default SDGCard;
